import { ReactNode, useState, useMemo } from "react";
import { ModalContext } from "./modalContext";
import { ModalConfig } from "./types";

type ModalProps = {
  children: ReactNode;
};

export const ModalProvider = ({ children }: ModalProps): JSX.Element => {
  const modalConfigDefault = {
    title: "Modal title",
    contentText: "Modal content text",
    cancelButtonLabel: "Cancel",
    submitButtonLabel: "Ok",
    onSubmit: () => null,
  };

  const [modalConfig, setModalConfig] =
    useState<ModalConfig>(modalConfigDefault);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = (config: ModalConfig) => {
    setModalConfig(config);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const valueMemo = useMemo(
    () => ({ modalConfig, modalIsOpen, openModal, closeModal }),
    [modalConfig, modalIsOpen]
  );

  return (
    <ModalContext.Provider value={valueMemo}>{children}</ModalContext.Provider>
  );
};
